/// Autofocus an element on page load.
/// If no selector is provided, focus the first input element.
const Marionette = require('backbone.marionette');

module.exports = Marionette.Behavior.extend({
    initialize: function({selector}) {
        this.autoFocusSelector = selector || ':input:first';
    },
    onDomRefresh: function() {
        _.defer(function() {
            this.view.$(this.autoFocusSelector).focus();
        }.bind(this));
    }
});
